<template>
    <div class="ur-data-grid__info-item ur-data-grid__action__selected-cnt" v-if="isSelCnt">
        <ur-icon icon="checked" iconType="picto"/>{{selText}}
    </div>
</template>

<script>
export default {
    name : 'urDataGridInfoModuleSelectedCnt',
    inject : ['gridInfo'],
    computed : {
        selCnt() {return this.gridInfo.vars_selLen},
        isSelCnt() {return this.selCnt && this.selCnt > 0},
        selText() {
            var template = this.gridInfo.opts.msgSelectedCnt;
            return template.replace('#',this.selCnt);
        }
    }
}

</script>